import React from 'react';
import BlogBanner from '../../components/BlogBanner';
import BlogSection from '../../components/BlogSection';

const Blog = () => {
  return (
    <div >
      <BlogBanner />
      <BlogSection />
    </div>
  );
};

export default Blog;
